import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email and we'll send you a secure reset link."
      footer={<Link to="/login" className="text-[#7A222B] font-semibold hover:underline" data-testid="back-to-signin">← Back to sign in</Link>}
    >
      {sent ? (
        <div data-testid="forgot-success" className="bg-[#F5EFE6] border border-[#EAE3DB] rounded-2xl p-6 text-center">
          <MailCheck className="w-10 h-10 text-[#7A222B] mx-auto" />
          <p className="mt-4 text-[#2D2825] font-medium">If that email is registered, a reset link has been sent.</p>
          <p className="mt-2 text-sm text-[#6E665E]">Check your inbox and spam folder. The link expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <div className="bg-[#FAF0F1] border border-[#D99B9F] text-[#7A222B] text-sm rounded-xl px-4 py-3">{error}</div>}
          <div>
            <label className="text-sm font-medium text-[#2D2825]">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email"
              className="mt-1.5 w-full rounded-xl border border-[#EAE3DB] bg-white px-4 py-3 text-[#2D2825] focus:outline-none focus:border-[#7A222B] focus:ring-2 focus:ring-[#7A222B]/10 transition"
              placeholder="you@college.edu"
            />
          </div>
          <button
            type="submit" disabled={loading} data-testid="forgot-submit-btn"
            className="w-full flex items-center justify-center gap-2 bg-[#7A222B] hover:bg-[#5C1D24] text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send reset link
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
